import styled from "styled-components";
import {CssRule} from "../../../../../../../themes/architecture/css-helpers/css-rule";

export const MoreDetailsLeftCornerDefaultBox = styled.div`
  background-image: url("${props => props.theme.assets.images.history.history_details_left_corner_png.toString()}");
  background-repeat: no-repeat;
  height: 35px;
  width: 65px;
  background-size: cover;
  ${CssRule.For.RTL.build()} & {
    transform: scaleX(-1);
  }
`;